const flatbuffers = require('flatbuffers')
const Ecg = require('../../../ecg_viewer_generated').Ecg

export default function getFlatBuffers(arr) {
  let a = new Uint8Array(arr)
  let inputByteBuffer = new flatbuffers.ByteBuffer(a)
  let signal = Ecg.Viewer.EcgSignal.getRootAsEcgSignal(inputByteBuffer)
  return signal
}
